function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconHomeRexOutline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M30 17h-4v10a2 2 0 01-2 2h-2v-2h2V15h1.17L16 5.828 6.828 15H8v12h2v2H8a2 2 0 01-2-2V17H2L16 3l14 14zm-12 2a2 2 0 012 2v8h-8v-8a2 2 0 012-2h4zm-4 8h4v-6h-4v6z",
    fill: props.color
  }));
}

export default SvgIconHomeRexOutline;